import {
  Box,
  BoxProps,
  ColorOptions,
  convertHexToRGBA,
  Image,
  ImageProps,
  Spacer,
  Text,
  useWindowDimensions,
} from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'

interface Props {
  title: string
  subTitle: string
  labels: string[]
  navigateTo: string
  imgUrl: any
  type: 'pg' | 'pos' | 'upihub' | 'jiobizz' | 'biller'
  onLayout?: any
}

const rightArrow = require('../../assets/images/arrow-right-blue.png')
const googlePlay = require('../../assets/images/google-play.png')

export const HomeContainer = ({ title, subTitle, labels, navigateTo, type, imgUrl, onLayout }: Props) => {
  const { textSize } = useFontSize()
  const resPadding = usePadding()

  const { navigate } = useNavigation()

  const viewPortWidth = useWindowDimensions()
  const isMobile = isMobileWidth(viewPortWidth)

  const themedStyle = styles(isMobile)
  return (
    <Box
      {...themedStyle[type].mainContainer}
      onLayout={onLayout && onLayout}
      nativeID={type}
      ph={resPadding}
      ID={type}
      testID={type}>
      <Box {...themedStyle[type].leftContainer}>
        <Box {...themedStyle[type].leftBox}>
          <Text title={title} fontFamily={'jiotype-black'} fontSize={isMobile ? 18 : 32} color={'BLACK_21'} />
          <Spacer size={16} />
          <Box paddingRight={isMobile ? 14 : 80}>
            <Text
              title={subTitle}
              fontFamily={'jiotype-medium'}
              fontSize={textSize}
              color={'BLACK_21'}
              opacity={0.9}
              lineHeight={isMobile ? 20 : 32}
            />
          </Box>
          <Spacer size={24} />
          <Box {...themedStyle[type].labelsContainer}>
            {labels.map((item: any) => {
              return (
                <Box
                  borderRadius={24}
                  bg={convertHexToRGBA(colors.JIO_PRIMARY_ALPHA, 8) as ColorOptions}
                  pv={8}
                  ph={16}
                  marginVertical={8}>
                  <Text title={item} fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'} opacity={0.9} />
                </Box>
              )
            })}
          </Box>
          <Box
            marginTop={isMobile ? 4 : 24}
            flexDirection={isMobile ? 'column' : 'row'}
            alignItems={isMobile ? undefined : 'center'}
            underlayColor={'TRANSPARENT'}
            onPress={() => navigate(navigateTo)}>
            {type === 'jiobizz' && <Spacer size={16} direction={'vertical'} />}

            <Box flexDirection={'row'} pv={12} align={'center'}>
              {type === 'jiobizz' && (
                <Image
                  source={googlePlay}
                  height={isMobile ? 40 : 48}
                  width={isMobile ? 130 : 162}
                  resizeMode="contain"
                />
              )}
              {type === 'jiobizz' && <Spacer size={32} direction={'horizontal'} />}
              <Text color={colors.HIGHLIGHT as ColorOptions} fontFamily="jiotype-medium" fontSize={isMobile ? 14 : 18}>
                {'Know More'}
              </Text>
              <Spacer direction={'horizontal'} size={8} />
              <Image source={rightArrow} height={24} width={24} resizeMode="contain" />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box {...themedStyle[type].rightContainer}>
        <Image {...themedStyle[type].imageBox} source={imgUrl} />
      </Box>
    </Box>
  )
}

const styles = (isMobile: boolean) => {
  return {
    pg: {
      mainContainer: {
        justify: isMobile ? undefined : 'space-between',
        marginTop: isMobile ? undefined : 120,
        flexDirection: isMobile ? 'column-reverse' : 'row',
      } as BoxProps,
      leftContainer: {
        f: isMobile ? undefined : 0.44,
      } as BoxProps,
      rightContainer: {
        f: isMobile ? undefined : 0.56,
      } as BoxProps,
      labelsContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 8,
      } as BoxProps,
      leftBox: {
        ph: isMobile ? 0 : 32,
        pv: isMobile ? 24 : 64,
      } as BoxProps,
      imageBox: {
        width: isMobile ? '100%' : 900,
        height: isMobile ? 250 : 650,
        resizeMode: 'center',
      } as ImageProps,
    },
    pos: {
      mainContainer: {
        justify: isMobile ? undefined : 'space-between',
        marginTop: isMobile ? 80 : 120,
        flexDirection: isMobile ? 'column-reverse' : 'row-reverse',
      } as BoxProps,
      leftContainer: {
        f: isMobile ? undefined : 0.5,
      } as BoxProps,
      rightContainer: {
        f: isMobile ? undefined : 0.5,
      } as BoxProps,
      leftBox: {
        pv: isMobile ? 24 : 105,
      } as BoxProps,
      labelsContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 8,
        w: isMobile ? '100%' : '60%',
      } as BoxProps,
      imageBox: {
        width: isMobile ? '100%' : 460,
        height: isMobile ? 250 : 560,
        resizeMode: 'center',
      } as ImageProps,
    },
    upihub: {
      mainContainer: {
        justify: isMobile ? undefined : 'space-between',
        marginTop: 80,
        flexDirection: isMobile ? 'column-reverse' : 'row',
      } as BoxProps,
      leftContainer: {
        f: isMobile ? undefined : 0.5,
        marginTop: isMobile ? -24 : 40,
      } as BoxProps,
      rightContainer: {
        f: isMobile ? undefined : 0.5,
        align: 'flex-end',
      } as BoxProps,
      labelsContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 8,
        w: isMobile ? undefined : '70%',
      } as BoxProps,
      leftBox: {
        pl: isMobile ? undefined : 32,
        pv: isMobile ? 24 : 64,
        pr: isMobile ? undefined : 100,
      } as BoxProps,
      imageBox: {
        width: isMobile ? '100%' : 560,
        height: isMobile ? 250 : 540,
        resizeMode: 'center',
      } as ImageProps,
    },
    biller: {
      mainContainer: {
        justify: isMobile ? undefined : 'space-between',
        flexDirection: isMobile ? 'column-reverse' : 'row-reverse',
        marginTop: 80,
      } as BoxProps,
      leftContainer: {
        f: isMobile ? undefined : 0.5,
        marginTop: isMobile ? undefined : 20,
      } as BoxProps,
      rightContainer: {
        f: isMobile ? undefined : 0.5,
      } as BoxProps,
      leftBox: {
        pv: isMobile ? 24 : 105,
      } as BoxProps,
      labelsContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 8,
        w: isMobile ? undefined : '60%',
      } as BoxProps,
      imageBox: {
        width: isMobile ? '100%' : 460,
        height: isMobile ? 250 : 560,
        resizeMode: 'center',
      } as ImageProps,
    },
    jiobizz: {
      mainContainer: {
        justify: isMobile ? undefined : 'space-between',
        flexDirection: isMobile ? 'column-reverse' : 'row',
      } as BoxProps,
      leftContainer: {
        f: isMobile ? undefined : 0.5,
        marginTop: isMobile ? 0 : 160,
      } as BoxProps,
      rightContainer: {
        f: isMobile ? undefined : 0.5,
      } as BoxProps,
      labelsContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 8,
        w: isMobile ? undefined : '85%',
      } as BoxProps,
      leftBox: {
        pl: isMobile ? 0 : 32,
        pr: isMobile ? 14 : 100,
      } as BoxProps,
      imageBox: {
        width: '100%',
        height: isMobile ? 250 : 650,
        resizeMode: 'center',
      } as ImageProps,
    },
  }
}
